import { cn } from '../lib/utils';

interface ProgressBarProps {
  value: number;
  size?: 'sm' | 'md';
  showLabel?: boolean;
  color?: string;
}

export default function ProgressBar({ value, size = 'sm', showLabel = false, color }: ProgressBarProps) {
  const clampedValue = Math.min(100, Math.max(0, value));

  const barColor = color ?? (
    clampedValue === 100
      ? 'bg-green-500'
      : clampedValue >= 60
      ? 'bg-blue-500'
      : clampedValue >= 30
      ? 'bg-yellow-500'
      : 'bg-gray-300'
  );

  return (
    <div className="flex items-center gap-2">
      <div className={cn('flex-1 bg-gray-100 rounded-full overflow-hidden', size === 'sm' ? 'h-1.5' : 'h-2.5')}>
        <div
          className={cn('h-full rounded-full transition-all duration-300', barColor)}
          style={{ width: `${clampedValue}%` }}
        />
      </div>
      {showLabel && (
        <span className="text-xs font-medium text-gray-500 w-8 text-right">{clampedValue}%</span>
      )}
    </div>
  );
}
